import {
  filter,
  tap,
  ignoreElements,
  switchMap,
  mergeMap,
  catchError,
} from 'rxjs/operators'
import {of, concat, from} from 'rxjs'
import {Epic} from 'redux-observable'
import {RootState, AppActions} from 'app/rootReducer'
import {PoliciesService} from 'services/api'
import {policiesActions} from '../policiesSlice'
import Toast from 'components/Basic/Toast'

const getPolicyAssigneeEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.getPolicyAssignee.match),
    switchMap(({payload}) =>
      from(PoliciesService.getPolicyAssignee(payload)).pipe(
        mergeMap(({data}) => [
          policiesActions.getPolicyAssigneeSuccess(data.Items),
        ]),
        catchError((message: string) =>
          concat(of(policiesActions.getPolicyAssigneeFailure(message))),
        ),
      ),
    ),
  )

const getPolicyAssigneeFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.getPolicyAssigneeFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const assignPolicyEpic: Epic<AppActions, AppActions, RootState> = action$ =>
  action$.pipe(
    filter(policiesActions.assignPolicy.match),
    switchMap(({payload}) =>
      from(PoliciesService.assignPolicy(payload)).pipe(
        mergeMap(() => [policiesActions.assignPolicySuccess()]),
        catchError((message: string) =>
          concat(of(policiesActions.assignPolicyFailure(message))),
        ),
      ),
    ),
  )

const assignPolicyFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.assignPolicyFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const assignPolicySuccessEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.assignPolicySuccess.match),
    tap(() => {
      Toast({message: 'Policy Updated Successfully', type: 'success'})
    }),
    ignoreElements(),
  )

const getPolicyClashGroupsEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.getPolicyClashGroups.match),
    switchMap(({payload}) =>
      from(PoliciesService.getPoliciesClashes(payload)).pipe(
        mergeMap(({data}) => [
          policiesActions.getPolicyClashGroupsSuccess(data),
        ]),
        catchError((message: string) =>
          concat(of(policiesActions.getPolicyClashGroupsFailure(message))),
        ),
      ),
    ),
  )

const getPolicyClashGroupsFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(policiesActions.getPolicyClashGroupsFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

export const usersEpics = [
  getPolicyAssigneeEpic,
  getPolicyAssigneeFailureEpic,
  assignPolicyEpic,
  assignPolicyFailureEpic,
  assignPolicySuccessEpic,
  getPolicyClashGroupsEpic,
  getPolicyClashGroupsFailureEpic,
]
